export default {
  verboseName: "Gruppo",
  verboseNamePlural: "Gruppi",
  modelName: "Band",
  modelNamePlural: "Bands",
  appName: "people",
  propName: "band",
  propNamePlural: "bands",
}
